import { render, staticRenderFns } from "./AGCBusinessRegistrationCertificate.vue?vue&type=template&id=0df680ed&scoped=true&"
import script from "./AGCBusinessRegistrationCertificate.vue?vue&type=script&lang=js&"
export * from "./AGCBusinessRegistrationCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df680ed",
  null
  
)

export default component.exports